export const BILLING_PERIODS = {
  MONTHLY: 'monthly',
  YEARLY: 'yearly'
};

export const formatUsdAmount = (value, locale) => {
  const amount = Number(value || 0);
  return new Intl.NumberFormat(locale || undefined, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number.isNaN(amount) ? 0 : amount);
};

export const getPromoBillingPeriodLabelKey = billingPeriod => {
  if (billingPeriod === BILLING_PERIODS.MONTHLY) return 'SALES.BILLING_PERIOD_MONTHLY';
  if (billingPeriod === BILLING_PERIODS.YEARLY) return 'SALES.BILLING_PERIOD_YEARLY';
  return 'SALES.BILLING_PERIOD_ANY';
};

export const isPlanBillingPeriodEnabled = (plan, billingPeriod) => {
  if (!plan) return false;
  if (billingPeriod === BILLING_PERIODS.YEARLY) {
    return Boolean(plan?.pricing?.yearly?.enabled);
  }
  return true;
};

export const getDefaultBillingPeriod = (promo, plan) => {
  if (promo?.applicable_billing_period === BILLING_PERIODS.MONTHLY) return BILLING_PERIODS.MONTHLY;
  if (promo?.applicable_billing_period === BILLING_PERIODS.YEARLY && isPlanBillingPeriodEnabled(plan, BILLING_PERIODS.YEARLY)) {
    return BILLING_PERIODS.YEARLY;
  }
  if (plan?.default_billing_period === BILLING_PERIODS.YEARLY && isPlanBillingPeriodEnabled(plan, BILLING_PERIODS.YEARLY)) {
    return BILLING_PERIODS.YEARLY;
  }
  return BILLING_PERIODS.MONTHLY;
};

export const getPlanQuote = (plan, billingPeriod, promo) => {
  if (!plan?.pricing) return null;

  const normalizedBillingPeriod = billingPeriod === BILLING_PERIODS.YEARLY && isPlanBillingPeriodEnabled(plan, BILLING_PERIODS.YEARLY)
    ? BILLING_PERIODS.YEARLY
    : BILLING_PERIODS.MONTHLY;
  const monthlyPricing = plan.pricing.monthly || {};
  const yearlyPricing = plan.pricing.yearly || {};
  const basePerMonth = normalizedBillingPeriod === BILLING_PERIODS.YEARLY ? yearlyPricing.usd_per_month : monthlyPricing.usd;
  const baseTotal = normalizedBillingPeriod === BILLING_PERIODS.YEARLY ? yearlyPricing.usd_total : monthlyPricing.usd;

  const promoRequiredPeriod = promo?.applicable_billing_period || 'any';
  const isCompatible = promoRequiredPeriod === 'any' || promoRequiredPeriod === normalizedBillingPeriod;

  const baseAmount = Number(baseTotal?.amount || 0);
  let discountAmount = 0;
  if (promo && isCompatible) {
    const discountValue = Number(promo.discount_value || 0);
    if (promo.discount_type === 'percentage') {
      discountAmount = baseAmount * (discountValue / 100);
    } else if (promo.discount_type === 'fixed_amount') {
      discountAmount = discountValue;
    } else if (promo.discount_type === 'free_months') {
      discountAmount = Number(basePerMonth?.amount || 0) * discountValue;
    }
  }

  if (discountAmount > baseAmount) {
    discountAmount = baseAmount;
  }

  return {
    billingPeriod: normalizedBillingPeriod,
    isCompatible,
    baseAmount,
    discountAmount,
    finalAmount: Math.max(baseAmount - discountAmount, 0),
    basePerMonth,
    baseTotal,
    yearlyDiscountPct: Number(yearlyPricing.discount_pct || 0)
  };
};